<template>
    <div :class="hidden ? 'd-none saving-wrapper' : 'saving-wrapper d-inline-block ml-2'">
        <div class="widget-saving" :class="hasError ? 'text-danger' : 'text-success'">
            {{ savedFraze }}
        </div>
    </div>
</template>

<script>
  export default {
    name: 'widget-saving',
    props: {
      show: {
        required: true,
      },
      hasError: {
        required: false,
      },
    },
    computed: {
      savedFraze() {
        let text = this.saved ? 'Сохранено' : 'Сохраняем...';
        if (this.hasError) {
          text = 'Ошибка при сохранении'
        }
        return text;
      },
    },
    watch: {
      show(val) {
        this.hidden = false;

        if (val == false) {
          this.saved = true;
        }
        else {
          this.saved = false;
        }

        let vm = this;
        if (vm.lastChange < Date.now() - 3100) {
          vm.lastChange = Date.now();
          setTimeout(function () {
            vm.hidden = true;
          }, 3000);
        }
      },
    },
    data() {
      return {
        hidden: true,
        lastChange: 0,
        saved: false,
      }
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/elements/WidgetSaving.vue